<script>
// Rodapé sticky (Cancelar/Restaurar padrão/Salvar) das rotas de Painel do
// Lead/Cliente e Visão Geral — segue o protótipo (aviso + ações à direita).
// `position: sticky` (não `fixed`) evita ter que calcular o offset da
// sidebar (padrão já usado em view-manage-professionals.vue `.bottom-action`).
// Cancelar/Salvar ficam desabilitados até `dirty` ser true — nada pra
// cancelar/salvar sem edição local pendente. "Restaurar padrão" NÃO segue
// essa regra: é um reset no SERVIDOR (apiCrmSummary.resetarLayout()), não
// descarte de edição local — sem edição pendente ainda é uma ação válida
// (ex.: reverter um layout salvo anteriormente pro default da plataforma).
// Gateá-lo por `!dirty` deixava a ação inalcançável sempre que a página
// carregava "limpa" (review PR #2206, MUST DO). `hideRestaurar` existe pq
// a Visão Geral esconde "Restaurar padrão" em scope escritorio (não há um
// nível acima pra herdar); default false pra não defaultar Boolean prop
// pra true (vue/no-boolean-default).
//
// Três props para montá-lo FORA da página cheia (a lateral da Home IA, onde
// a preferência é POR PROFISSIONAL): `semAviso` tira o texto "vale para todo
// o escritório" (lá seria falso), `embutido` desliga o sticky/full-bleed
// (não há padding de página a estourar) e `cancelarSemEdicao` libera o
// Cancelar sem `dirty` — lá ele é a saída do editor, não só o descarte.
export default {
  name: 'PersonalizacaoFooterActions',
  props: {
    dirty: { type: Boolean, default: false },
    loadingSave: { type: Boolean, default: false },
    loadingReset: { type: Boolean, default: false },
    hideRestaurar: { type: Boolean, default: false },
    semAviso: { type: Boolean, default: false },
    embutido: { type: Boolean, default: false },
    cancelarSemEdicao: { type: Boolean, default: false },
  },
  computed: {
    cancelarDesabilitado() {
      if (this.loadingSave) return true
      return !this.dirty && !this.cancelarSemEdicao
    },
  },
}
</script>

<template>
  <footer
    class="personalizacaoFooter d-flex align-center"
    :class="{
      'justify-space-between': !semAviso,
      'justify-end': semAviso,
      'personalizacaoFooter--embutido ma-0 px-0 pt-5 pb-3': embutido,
    }"
  >
    <div v-if="!semAviso" class="d-flex align-center">
      <icon-svg name="info" size="18" color="var(--text-muted)" class="mr-2" />
      <span class="az-ds-aux ma-0">
        As mudanças valem para todo o escritório assim que salvas.
      </span>
    </div>

    <div
      class="d-flex align-center"
      :class="
        embutido ? 'flex-wrap az-gap-small' : 'personalizacaoFooter__actions'
      "
    >
      <BaseButton
        v-if="!hideRestaurar"
        underlined
        fitContent
        :loading="loadingReset"
        :disabled="loadingSave || loadingReset"
        @click="$emit('reset')"
      >
        Restaurar padrão
      </BaseButton>
      <BaseButton
        underlined
        :disabled="cancelarDesabilitado"
        @click="$emit('cancel')"
      >
        Cancelar
      </BaseButton>
      <BaseButton
        primary
        :disabled="!dirty"
        :loading="loadingSave"
        @click="$emit('save')"
      >
        Salvar
      </BaseButton>
    </div>
  </footer>
</template>

<style lang="sass" scoped>
// Full-bleed: o ancestral .container-sm (view-crm-settings.vue) tem
// padding-left/right 24px (20px abaixo de 600px) — margin negativo do
// mesmo valor estoura essa moldura pra o rodapé ocupar toda a largura do
// conteúdo, e o padding interno repõe o respiro do texto/botões.
.personalizacaoFooter
  position: sticky
  bottom: 0
  z-index: 5
  margin-top: 24px
  margin-left: -24px
  margin-right: -24px
  padding: 16px 24px
  background: var(--white, #fff)
  border-top: 1px solid var(--border-hairline)
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.04)

  @media (max-width: 600px)
    margin-left: -20px
    margin-right: -20px
    padding-left: 20px
    padding-right: 20px

  &__actions
    gap: 24px

  // Dentro de uma coluna (ver o comentário do `<script>`): sem sticky e sem
  // sombra; o fundo é o de quem monta. Margens/padding/gap vêm de utilitário.
  &--embutido
    position: static
    background: transparent
    box-shadow: none
</style>
